module.exports = __webpack_public_path__ + "img/photo-0141.9490b5c2.jpg";